/**
 * External dependencies
 */
import { reducer as form } from 'redux-form';
import { combineReducers } from 'redux';

/**
 * Reducers
 */
import application from './application/reducer';
import currentUser from "./current-user/reducer";
import currentSupport from './current-support/reducer';
import documentHead from './document-head/reducer';
import notices from './notices/reducer';
import ui from "./ui/reducer";
import users from "./users/reducer";
import subscriptions from './subscriptions/reducer';
import supportPlans from './support-plans/reducer';
import paymentMethods from './payment-methods/reducer';
import invoices from './invoices/reducer';
import addons from './addons/reducer';
import coupons from './coupons/reducer';
import currentRental from './current-rental/reducer';
import currentRetailerRental from './current-retailer-rental/reducer';
import retailerRentalPlans from './rental-plans/reducer';
import currentCloudHosting from './current-cloud-hosting/reducer';
import currentWeb from './current-web/reducer';
import webPlans from './web-plans/reducer';
import currentDispatch from './current-dispatch/reducer';
import dispatchPlans from './dispatch-plans/reducer';
import cloudBackupPlans from './cloud-backup-plans/reducer';
import currentCloudBackup from './current-cloud-backup/reducer';
import currentBarcodeLookup from './current-barcode-lookup/reducer';
import barcodeLookupPlans from './barcode-lookup-plans/reducer';
import currentRoam from './current-roam/reducer';
import roamPlans from './roam-plans/reducer';
import currentTsPay from './current-tspay/reducer';
import planNames from './plan-names/reducer';
import currentKiosk from './current-kiosk/reducer';
import kioskPlans from './kiosk-plans/reducer';
import currentVisualDeck from './current-visual-deck/reducer';
import visualDeckPlans from './visual-deck-plans/reducer';
import currentUniversalImporter from './current-universal-importer/reducer';
import universalImporterPlans from './universal-importer-plans/reducer';
import loadingProgress from './loading-progress/reducer';


// Please keep this list alphabetized!
const reducers = {
    application,
    addons,
    coupons,
    currentCloudHosting,
    currentDispatch,    
    currentRental,
    currentRetailerRental,
    retailerRentalPlans,
    currentWeb,
    currentUser,
    currentSupport,
    documentHead,
    dispatchPlans,
    form,
    invoices,
    notices,
    paymentMethods,
    subscriptions,
    supportPlans,
    ui,
    users,
    webPlans,
    cloudBackupPlans,
    currentCloudBackup,
    barcodeLookupPlans,
    currentBarcodeLookup,
    roamPlans,
    currentRoam,
    currentTsPay,
    planNames,
    kioskPlans,
    currentKiosk,
    visualDeckPlans,
    currentVisualDeck,
    universalImporterPlans,
    currentUniversalImporter,
    loadingProgress,
}

export default combineReducers( reducers );